<template>
  <div style="height:100%;width:100%;display:flex;flex-direction:row;">
    <Portlet class="main-portlet" :fullHeight="true" :headSeparator="true">
      <template slot="Title">
        <router-view name="subPageHeader"></router-view>
      </template>
      <template slot="Options">
        <router-view name="pageActions"></router-view>
      </template>
      <template slot="PortletNav">
        <router-view name="pageSubMenu"></router-view>
      </template>
      <template slot="Content">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
        <!-- Modal Edition -->
        <ClockEditionCard :clockUid="editedClockUid" v-if="isEditingClock"></ClockEditionCard>
      </template>
    </Portlet>
    <router-view name="rightPanel"></router-view>
  </div>
</template>

<script>
import store from "@/store";
import Portlet from "@/components/common/Portlet.vue";
import { mapState, mapMutations, mapActions } from "vuex";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import ClockEditionCard from "../Clocks/ClockEditionCard.vue";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
export default {
  name: "MasterClocks",
  store,
  created() {
    EventBus.$on("onClockEdition", this.editClock);
    EventBus.$on("onClockEditionEnded", this.stopEditClock);
    EventBus.$on("onClockDuplicate", this.onClockDuplicate);
    EventBus.$on("onClockDuplicateEnded", () => {
      console.log("EventBus - onClockDuplicateEnded");
      store.commit("onClockDuplicateEnded");
    });
  },
  beforeDestroy(){
    EventBus.$off("onClockEdition", this.editClock);
    EventBus.$off("onClockEditionEnded", this.stopEditClock);
    EventBus.$off("onClockDuplicate", this.onClockDuplicate);
  },
  components: {
    Portlet,
    ClockEditionCard
  },
  computed: {
    Translations: () => Translations
  },
  data() {
    return {
      editedClockUid: null,
      isEditingClock: false
    };
  },
  methods: {
    editClock: function(clockUid) {
      this.editedClockUid = clockUid;
      this.isEditingClock = true;
    },
    stopEditClock: function() {
      this.isEditingClock = false;
    },
    async onClockDuplicate(clockUid) {
      console.log('duplicate id: ', clockUid);
      try {
        const response = await HTTP.post(Apis.clocks.duplicate, {
          stationUid: this.$route.params.stationUid,
          clockUid: clockUid
        });

        const data = await response.data.dataItem;

        await store.dispatch("loadStationClocks", this.$route.params.stationUid);
        await this.$router.push({
          name: "ClockDetails",
          params: { clockUid: data.uid }
        });
      } catch (e) {
        console.log("error duplicat clock :", e);
      }
    }
  }
};
</script>

<style>
.main-portlet {
  width: 100%;
}
</style>
